import { createTheme } from "@mantine/core";

export const theme = createTheme({
  colors: {
    primary: [
      "#BCC1C0",
      "#ccecef",
      "#99d9de",
      "#66c6cd",
      "#3fb2b8",
      "#289ba3",
      "#1e848d",
      "#176b72",
      "#105258",
      "#08393d",
    ],
  },
  primaryColor: "primary",
  primaryShade: 6,
  fontFamily: '"Avenir Next", sans-serif',

  headings: {
    fontFamily: '"Avenir Next", sans-serif',
    sizes: {
      h1: {
        fontSize: "22px",
        fontWeight: "600",
        lineHeight: "1.2",
        letterSpacing: "-0.242px",
      },
      h2: {
        fontSize: "18px",
        fontWeight: "600",
        lineHeight: "1.3",
        letterSpacing: "-0.1px",
      },
    },
  },

  fontSizes: {
    md: "16px",
    sm: "14px",
  },

  components: {
    Input: {
      styles: {
        input: {
          border: "black 0.5px solid",
          backgroundColor: "#F6F1F1",
          borderRadius: "6px",
          color: "#646464",
          fontWeight: 500,
        },
      },
    },
    Button: {
      vars: (theme, props) => {
        if (props.fullWidth) {
          return {
            root: {
              "--button-width": "100%",
              "--button-display": "block",
            },
          };
        }
        return { root: {} };
      },
    },
    Combobox: {
      styles: {
        dropdown: {
          backgroundColor: "#ffffff",
          background: "#ffffff",
        },
        options: {
          backgroundColor: "#ffffff",
        },
      },
    },
    Popover: {
      styles: {
        dropdown: {
          backgroundColor: "#ffffff !important",
          background: "#ffffff !important",
          border: "1px solid #dee2e6 !important",
          boxShadow: "var(--mantine-shadow-md)",
        },
      },
    },
    Select: {
      styles: {
        dropdown: {
          backgroundColor: "#ffffff",
          background: "#ffffff",
          border: "1px solid #dee2e6",
        },
      },
    },
  },
});
